import { useDispatch, useSelector } from 'react-redux';
import { push } from 'redux-first-history';
import ChecklistPage from './component';
import { DEFAULT_ERROR } from '@rental-manager/constants/NotificationConstants';
import { useCreateLandlordWebApiHandler_createLandlord } from '@zg-rentals/ts-rent-payment-client-react-query';
import { acceptTerms as saveAcceptTerms } from '@rental-manager/actions/OnboardingActions';
import { closeNotification, showModalNotification } from '@common/actions/NotificationActions';
import paths from '@rental-manager/pathsManifest';
import { LANDLORD_STATUS } from '@rental-manager/constants/OnboardingConstants';
import { logError } from '@zg-rentals/log-error';
import type { CreateLandlordWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

interface ContainerProps {
  baseUrl: string;
  propertyId: string;
  landlordStatus: string;
  acceptTerms?: boolean;
}

const ChecklistPageContainer = ({
  baseUrl,
  propertyId,
  landlordStatus,
  acceptTerms: acceptTermsProp,
}: ContainerProps) => {
  const dispatch: any = useDispatch();

  const email = useSelector((state: any) => state.user.email);
  const acceptTerms = useSelector(
    (state: any) => state.payments.landlord.onboarding[propertyId]?.acceptTerms || acceptTermsProp,
  );
  const leasesForProperty = useSelector(
    (state: any) => state.payments.landlord.onboarding[propertyId].leasesForProperty,
  );
  const user = useSelector((state: any) => state.user);
  const currentProperty = useSelector((state: any) => state.payments.landlord.property.listingDetails);

  const { mutateAsync: createLandlord } = useCreateLandlordWebApiHandler_createLandlord({
    meta: {
      context: {
        api: 'createLandlord',
        details: 'Create landlord during onboarding',
      },
    },
  });

  const onSubmit = async () => {
    try {
      await dispatch(closeNotification());
      await dispatch(saveAcceptTerms({ propertyId }));

      if (landlordStatus === LANDLORD_STATUS.NOT_STARTED) {
        await createLandlord({
          postData: {
            acceptTerms,
            email,
            propertyId,
          } as CreateLandlordWebApiRequestDto,
        });
      }

      dispatch(
        push({
          pathname:
            baseUrl +
            (leasesForProperty.length > 0 ? paths.onboarding.leaseSelectorPage : paths.onboarding.rentAmountPage),
          search: 'acceptTerms=true',
        }),
      );
    } catch (err) {
      logError({ error: err });
      dispatch(showModalNotification(DEFAULT_ERROR));
      return { error: true };
    }
  };

  const onClose = async () => {
    await dispatch(closeNotification());
    dispatch(push(baseUrl + paths.onboarding.exitPaymentSetup));
  };

  return <ChecklistPage onSubmit={onSubmit} onClose={onClose} user={user} currentProperty={currentProperty} />;
};

export default ChecklistPageContainer;
